import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch, useParams, useHistory, useLocation } from "react-router-dom";

import cx from 'classnames';
import _ from 'lodash';
import dateformat from "dateformat";
import moment from 'moment'
import { Button } from 'react-bootstrap';

import { fetchingFirstCapturedLeads, fetchingLatestCampaignLeads, fetchingLeadsJourney, fetchingStoryboardLeadDetails, invalidateStoryboardLeadDetails } from 'actions/leads';
import { PageInteractions } from '../components/pageInteractions';
import InfiniteScroll from 'components/InfiniteScroll';
import LinesEllipsis from 'react-lines-ellipsis'
import { renderInitials } from '../components';
import { AssetInteractions } from '../components/assetInteractions';
import { getBaseUrl, padNumber } from 'services/util';

import styles from './leadProfile.module.scss';
import Tooltip from 'components/Tooltip';


const LeadProfile = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  let { storyboardId } = useParams();

  let { path, url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  const handleBackClick = () => {
    var url = `${baseUrl}/storyboards/${storyboardId}/leads`;
    history.push(url);

    dispatch(invalidateStoryboardLeadDetails())
  }

  const { profileId, reportDate } = location.state;

  const leadProfile = useSelector(state => _.get(state, 'lead.summary.visitor', {}));
  const loading = useSelector(state => _.get(state, 'lead.summary.loading'));

  useEffect(() => {

    const request = {
      storyboard: storyboardId,
      metricType: "leads",
      startDate: _.get(reportDate, 'startDate'),
      endDate: _.get(reportDate, 'endDate')
    }

    dispatch(fetchingStoryboardLeadDetails(profileId, request))
  }, [])

  const _renderTimeSpent = (seconds) => {
    let minutes = padNumber(Math.floor(seconds / 60), 2);
    seconds = padNumber(Math.floor(seconds % 60), 2);
    var hours = padNumber(Math.floor(minutes / 60), 2);
    minutes = padNumber(minutes % 60, 2);

    hours = hours > 0 ? `${hours}:` : '00'
    return `${hours}:${minutes}:${seconds}`;
  }

  const _renderLastActivity = () => {
    if (loading) {
      return;
    }

    const lastEventDate = dateformat(leadProfile.lastEventDate, 'ddmmyyyy,h:MM:ss TT')
    return moment(lastEventDate, 'DDMMYYYY,h:mm:ss a').fromNow();
  }

  return (
    <div className={styles.leadProfile}>
      <section className={styles.detailsContainer}>
        <div className={styles.navigationPanel}>
          <Button variant="light" onClick={handleBackClick} className={styles.backButton}>
            <i className={cx(styles.backIcon, 'cleverstory-back')} />
            Leads
          </Button>

          {/* <Button variant='info' className={styles.menuButton}>
            <i className={cx(styles.backIcon, 'cleverstory-more')} />
          </Button> */}
        </div>
        <div className={styles.profileOverview}>
          <div className={styles.basicInfo}>
            <div className={styles.imageContainer}>
              <div className={styles.visitorInitials}>{renderInitials(leadProfile)}</div>
            </div>
            <div className={styles.details}>
              <h4 className={styles.name}>{leadProfile.firstName ? leadProfile.firstName : '' + ' ' + leadProfile.lastName ? leadProfile.lastName : ''}</h4>
              <p className={styles.email}>{_.get(leadProfile, 'email', "")}</p>
              <p className={styles.last_activity}>Last Activity: {_renderLastActivity()}</p>
            </div>
          </div>
          <div className={styles.recordsWrapper}>
            <LeadRecords heading="Views" subheading="Recorded" data={Math.round(_.get(leadProfile, 'views', 0))} path={'/images/reports/sessions.svg'} />
            <LeadRecords heading="Total Time" subheading="Spent" data={_renderTimeSpent(_.get(leadProfile, 'timeSpent', 0))} path={'/images/leads/timeSpent.svg'} />
            <LeadRecords heading="Completion" subheading="Percentage" data={`${_.get(leadProfile, 'completion', 0)}%`} path={'/images/leads/completion.svg'} />
          </div>
        </div>
        <div className={styles.profileDetails}>
          <LeadDetails profileId={profileId} reportDate={reportDate} />
          <LeadJourney profileId={profileId} reportDate={reportDate} />
        </div>
      </section>
      <div className={styles.interactions}>
        <PageInteractions profileId={profileId} reportDate={reportDate} />
        <AssetInteractions profileId={profileId} reportDate={reportDate} />
      </div>
    </div>
  )
}

const LeadRecords = ({ heading, subheading, data, path, iconClassname }) => {
  return (
    <div className={styles.statistics}>
      <div className={styles.content}>
        <h6 className={styles.heading}>{heading}</h6>
        <span className={styles.sub_heading}>{subheading}</span>
        <span className={styles.stat}>{data}</span>
      </div>
      <div className={styles.icon}>
        <img src={path} className={iconClassname} />
      </div>
    </div>
  )
}

const LeadDetails = ({ profileId, reportDate }) => {
  const dispatch = useDispatch();
  let { storyboardId } = useParams();

  const { startDate, endDate } = reportDate;

  const leadProfile = useSelector(state => _.get(state, 'lead.summary.visitor', {}));
  const detailsloader = useSelector(state => _.get(state, 'lead.summary.loading'));
  const firstCapturedLead = useSelector(state => _.get(state, 'lead.firstCaptured.items', {}));
  const latestCampaignLead = useSelector(state => _.get(state, 'lead.latestCampaign.items', {}));


  useEffect(() => {
    const dataRequest = {
      storyboard: storyboardId,
      metricType: "leads",
      startDate: startDate,
      endDate: endDate
    }

    dispatch(fetchingFirstCapturedLeads(profileId, dataRequest))
    dispatch(fetchingLatestCampaignLeads(profileId, dataRequest))
  }, [])

  return (
    <div className={styles.leadDetailsSection}>
      <section className={styles.sectionContainer}>
        <header className={styles.sectionHeader}>
          <h4 className={styles.sectionHeading}>Lead Info</h4>
          <hr className={styles.separator_line} />
          {/* <button className={styles.btn_edit}><i className='cleverstory-edit'></i></button> */}
        </header>

        <div className={styles.detailContainer}>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>First Name</h6>
            <span className={styles.detailValue}>{leadProfile.firstName ? leadProfile.firstName : '-'}</span>
          </div>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Email</h6>
            <span className={styles.detailValue}>{leadProfile.email ? leadProfile.email : '-'}</span>
          </div>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Last Name</h6>
            <span className={styles.detailValue}>{leadProfile.lastName ? leadProfile.lastName : '-'}</span>
          </div>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Company</h6>
            <span className={styles.detailValue}>{leadProfile.company ? leadProfile.company : '-'}</span>
          </div>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Designation</h6>
            <span className={styles.detailValue}>{leadProfile.title ? leadProfile.title : '-'}</span>
          </div>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Work Phone</h6>
            <span className={styles.detailValue}>{leadProfile.workPhone ? leadProfile.workPhone : '-'}</span>
          </div>
        </div>
      </section>
      <div className={styles.firstCapturedContainer}>
        <h4 className={styles.firstCaptured_heading}>
          <p className={styles.heading1}>First</p>
          <p className={styles.heading2}>Captured</p>
        </h4>
        <div className={styles.subContainer}>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Date</h6>
            <p className={styles.detailValue}>{dateformat(firstCapturedLead.firstCapturedDate, 'dd mmm yyyy')}</p>
          </div>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Campaign Name</h6>
            <RenderName className={styles.detailValue} data={firstCapturedLead.campaignName} />
          </div>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Source/Medium</h6>
            <RenderName className={styles.detailValue} data={firstCapturedLead.campaignMedium ? `${firstCapturedLead.campaignSource} / ${firstCapturedLead.campaignMedium}` : '-'} />
          </div>
        </div>
        <div className={styles.firstCaptureIcon}>
          <img src='/images/leads/first_captured.svg' />
        </div>
      </div>

      <section className={styles.sectionContainer}>
        <header className={styles.sectionHeader}>
          <h4 className={styles.sectionHeading}>Latest Campaign</h4>
          <hr className={styles.separator_line} />
          {/* <button className={styles.btn_edit}><i className='cleverstory-edit'></i></button> */}
        </header>
        <div className={styles.latestCampaignDetailContainer}>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Campaign Name</h6>
            <RenderName className={styles.detailValue} data={latestCampaignLead.campaignName ? latestCampaignLead.campaignName : '-'} />
          </div>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Source</h6>
            <RenderName className={styles.detailValue} data={latestCampaignLead.campaignSource ? latestCampaignLead.campaignSource : '-'} />
          </div>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Medium</h6>
            <RenderName className={styles.detailValue} data={latestCampaignLead.campaignMedium ? latestCampaignLead.campaignMedium : '-'} />
          </div>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Content</h6>
            <RenderName className={styles.detailValue} data={latestCampaignLead.content ? latestCampaignLead.content : '-'} />
          </div>
        </div>
      </section>
    </div>
  )
}

const RenderName = ({ data, className }) => {
  const [tooltip, setTooltip] = useState(false);

  const handleTooltip = (truncated) => {
    const { clamped } = truncated;
    setTooltip(clamped);
  }

  if (!data) {
    return (
      <span className={styles.detailValue}>{'-'}</span>
    )
  }

  return (
    <Tooltip placement="top" disabled={!tooltip} content={data}>
      <span className={className}>
        <LinesEllipsis basedOn="letters" onReflow={handleTooltip} text={data} maxLine='1' ellipsis='...' />
      </span>
    </Tooltip>
  )
}


const LeadJourney = ({ profileId, reportDate }) => {
  const dispatch = useDispatch();
  let { storyboardId } = useParams();

  useEffect(() => {
    if (reportDate) {
      handleLeadsJourney(0)
    }
  }, [reportDate])

  const journeyData = useSelector(state => _.get(state, 'lead.journey.items', [])) || [];
  const loading = useSelector(state => _.get(state, 'lead.journey.loading'));
  const pagination = useSelector(state => _.get(state, 'lead.journey.pagination', {}));
  const hasMoreItems = _.get(pagination, "currentPage") < _.get(pagination, "totalPages") - 1;

  const handlePageChange = () => {
    const nextPage = pagination.currentPage + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }

    handleLeadsJourney(nextPage);
  }

  const handleLeadsJourney = (page) => {
    if (!storyboardId) {
      return
    }

    const request = {
      storyboard: storyboardId,
      startDate: _.get(reportDate, 'startDate'),
      endDate: _.get(reportDate, 'endDate')
    }

    dispatch(fetchingLeadsJourney(profileId, request, page, 20))
  }

  return (
    <section className={styles.leadJourney}>
      <h6 className={styles.sectionHeading}>Lead Journey</h6>
      <div className={styles.journeyContainer}>
        <InfiniteScroll
          className={cx(styles.scrollable)}
          loading={loading}
          hasMore={hasMoreItems}
          loadMore={() => { handlePageChange() }}
        >
          {journeyData.map((interaction, index) => {
            return (
              <div key={index} className={styles.journeyDetails}>
                <div className={styles.journeyTimeline}>
                  <span>{dateformat(interaction.eventDate, 'dd mmm yyyy')}</span>
                </div>
                <div className={styles.journeyInteraction}>
                  <span className={styles.type}>{_.get(interaction, 'type', '')}</span>
                  <span className={styles.name}>{_.get(interaction, 'name', '')}</span>
                  {_.get(interaction, 'campaign') !== null && <span className={styles.campaign}>{`${_.get(interaction, 'campaign.source', '')}/${_.get(interaction, 'campaign.medium', '')}`}</span>}
                </div>
              </div>
            )
          })
          }
        </InfiniteScroll>
      </div>
    </section>
  )
}

export default LeadProfile